<template>
  <div class="seller-dashboard">
    <SellerSidebar />

    <main class="main-content">
      <section class="content-wrapper">
        <router-view v-slot="{ Component, route }">
          <transition name="page-fade" mode="out-in">
            <component :is="Component" :key="route.fullPath" />
          </transition>
        </router-view>
      </section>

      <div v-if="showAfterSalesNotification" class="notification-modal">
        <div class="modal-content">
          <div class="modal-header">
            <h3>新的售后申请</h3>
            <button class="close-btn" @click="closeNotification">×</button>
          </div>
          <div class="modal-body">
            <p><strong>售后单号:</strong> {{ notificationData.afterSalesId }}</p>
            <p><strong>订单号:</strong> {{ notificationData.orderNumber }}</p>
            <p><strong>商品 SKU:</strong> {{ notificationData.sku }}</p>
            <p><strong>商品信息:</strong> {{ notificationData.productName }}</p>
            <p><strong>用户诉求:</strong> {{ notificationData.reason }}</p>
            <p><strong>申请类型:</strong> {{ notificationData.type }}</p>
            <p><strong>申请时间:</strong> {{ notificationData.createdAt }}</p>
          </div>
          <div class="modal-footer">
            <button class="btn btn-secondary" @click="closeNotification">稍后处理</button>
            <button class="btn" @click="gotoAfterSales">立即查看</button>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import SellerSidebar from '../components/SellerSidebar.vue'

export default {
  name: 'SellerDashboard',
  components: {
    SellerSidebar
  },
  data() {
    return {
      showAfterSalesNotification: false,
      notificationData: {}
    }
  },
  methods: {
    async checkNewAfterSalesRequests() {
      try {
        const hasNewRequest = true
        if (hasNewRequest) {
          this.notificationData = {
            id: 4,
            productName: '商品 D',
            reason: '商品损坏',
            type: '退款',
            createdAt: '2024-01-04 10:00:00'
          }
          this.showAfterSalesNotification = true
        }
      } catch (err) {
        console.error('检查售后申请失败', err)
      }
    },
    closeNotification() {
      this.showAfterSalesNotification = false
    },
    gotoAfterSales() {
      this.showAfterSalesNotification = false
      this.$router.push('/seller/dashboard/after-sales')
    }
  }
}
</script>

<style scoped>
.seller-dashboard {
  display: flex;
  min-height: 100vh;
  align-items: flex-start;
}

.main-content {
  flex: 1;
  margin-left: 292px;
  padding: 5.4rem 1.5rem 1.5rem;
  min-height: 100vh;
  position: relative;
  overflow: hidden;
}

.content-wrapper {
  width: min(100%, 1200px);
  margin: 0 auto;
  padding: 1.75rem;
  border-radius: 32px;
  border: 1px solid rgba(255, 255, 255, 0.7);
  background: rgba(255, 255, 255, 0.72);
  backdrop-filter: var(--backdrop-blur);
  -webkit-backdrop-filter: var(--backdrop-blur);
  box-shadow: var(--shadow-soft);
}

.main-content::before,
.main-content::after {
  content: '';
  position: fixed;
  border-radius: 50%;
  pointer-events: none;
  filter: blur(18px);
  z-index: 0;
}

.main-content::before {
  top: 100px;
  right: 6%;
  width: 360px;
  height: 360px;
  background: radial-gradient(circle, rgba(0, 113, 227, 0.12), transparent 68%);
  animation: sellerAmbient 18s ease-in-out infinite;
}

.main-content::after {
  left: 4%;
  bottom: 6%;
  width: 420px;
  height: 420px;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.96), rgba(220, 234, 255, 0.35) 42%, transparent 72%);
  animation: sellerAmbientReverse 22s ease-in-out infinite;
}

.content-wrapper {
  position: relative;
  z-index: 1;
}

:deep(.header-container),
:deep(.page-header) {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 1rem;
  margin-bottom: 1.6rem;
  padding-bottom: 1.1rem;
  border-bottom: 1px solid var(--color-border);
}

:deep(.header-container h1),
:deep(.page-title),
:deep(.card-title),
:deep(h2) {
  color: var(--color-text);
  letter-spacing: -0.04em;
}

:deep(.header-container h1),
:deep(.page-title) {
  margin: 0;
  font-size: clamp(1.9rem, 3vw, 2.6rem);
}

:deep(.card),
:deep(.form-card),
:deep(.modal),
:deep(.modal-content),
:deep(.provider-item),
:deep(.order-card),
:deep(.stats-card),
:deep(.summary-card),
:deep(.chart-card),
:deep(.history-card) {
  border: 1px solid rgba(255, 255, 255, 0.76);
  background: rgba(255, 255, 255, 0.82);
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
  box-shadow: var(--shadow-soft);
}

:deep(.card),
:deep(.form-card),
:deep(.order-card),
:deep(.stats-card),
:deep(.summary-card),
:deep(.chart-card),
:deep(.history-card) {
  border-radius: 26px;
}

:deep(.form-wrapper),
:deep(.orders-list),
:deep(.dashboard-grid),
:deep(.cards-grid) {
  display: grid;
  gap: 1rem;
}

:deep(.card-header),
:deep(.order-header),
:deep(.modal-header) {
  background: rgba(15, 23, 42, 0.03);
  border-bottom: 1px solid var(--color-border);
}

:deep(.order-header),
:deep(.card-header) {
  border-radius: 26px 26px 0 0;
}

:deep(.form-label),
:deep(.label),
:deep(.help-text),
:deep(.info-row .label),
:deep(.product-quantity),
:deep(.order-time),
:deep(.placeholder-text),
:deep(.provider-code) {
  color: var(--color-text-soft);
}

:deep(.form-input),
:deep(.form-select),
:deep(.form-control),
:deep(textarea),
:deep(select),
:deep(input[type='text']),
:deep(input[type='number']),
:deep(input[type='password']),
:deep(input[type='tel']),
:deep(input[type='email']) {
  border-radius: 16px;
  border: 1px solid var(--color-border);
  background: rgba(255, 255, 255, 0.92);
  transition:
    border-color var(--duration-fast) var(--ease-standard),
    box-shadow var(--duration-fast) var(--ease-standard),
    transform var(--duration-fast) var(--ease-standard);
}

:deep(.form-input:focus),
:deep(.form-select:focus),
:deep(.form-control:focus),
:deep(textarea:focus),
:deep(select:focus),
:deep(input:focus) {
  outline: none;
  border-color: rgba(0, 113, 227, 0.42);
  box-shadow: var(--shadow-focus);
}

:deep(.btn),
:deep(.btn-back),
:deep(.action-btn),
:deep(.form-actions button),
:deep(.btn-sm) {
  border-radius: 999px;
  transition:
    transform var(--duration-fast) var(--ease-standard),
    box-shadow var(--duration-fast) var(--ease-standard),
    background-color var(--duration-fast) var(--ease-standard);
}

:deep(.btn:hover),
:deep(.btn-back:hover),
:deep(.action-btn:hover),
:deep(.btn-sm:hover) {
  transform: translateY(-1px);
}

:deep(.btn-secondary),
:deep(.btn-back),
:deep(.btn-sm) {
  background: rgba(15, 23, 42, 0.05);
  color: var(--color-text);
  border: 1px solid var(--color-border);
}

:deep(.btn-danger) {
  background: rgba(192, 57, 43, 0.12);
  color: #9d3024;
  border: 1px solid rgba(192, 57, 43, 0.14);
}

:deep(.btn-primary) {
  background: linear-gradient(135deg, #111113, #2c2c2e);
}

:deep(table),
:deep(.category-table) {
  border-radius: 20px;
  overflow: hidden;
  box-shadow: none;
}

:deep(th) {
  background: rgba(15, 23, 42, 0.03);
  color: var(--color-text-soft);
}

:deep(td),
:deep(th) {
  border-bottom: 1px solid var(--color-border);
}

:deep(.status-active),
:deep(.status-inactive),
:deep(.status-badge),
:deep(.provider-item.selected) {
  border-radius: 999px;
}

:deep(.status-active) {
  background: rgba(31, 157, 85, 0.1);
  color: #1c6b3f;
}

:deep(.status-inactive) {
  background: rgba(15, 23, 42, 0.06);
  color: var(--color-text-soft);
}

:deep(.modal-overlay) {
  background: rgba(15, 23, 42, 0.3);
  backdrop-filter: blur(8px);
}

:deep(.modal),
:deep(.modal-content) {
  border-radius: 28px;
  overflow: hidden;
}

:deep(.loading-container),
:deep(.loading),
:deep(.empty-state),
:deep(.no-providers) {
  color: var(--color-text-soft);
}

@keyframes sellerAmbient {
  0%, 100% {
    transform: translate3d(0, 0, 0) scale(1);
  }
  50% {
    transform: translate3d(-28px, 22px, 0) scale(1.05);
  }
}

@keyframes sellerAmbientReverse {
  0%, 100% {
    transform: translate3d(0, 0, 0) scale(1);
  }
  50% {
    transform: translate3d(32px, -18px, 0) scale(0.95);
  }
}

.notification-modal {
  position: fixed;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(15, 23, 42, 0.28);
  backdrop-filter: blur(8px);
  z-index: 1100;
}

.modal-body {
  padding: 1.25rem 1.4rem;
  line-height: 1.7;
  color: var(--color-text-soft);
}

.modal-body p {
  margin: 0.45rem 0;
}

.modal-body strong {
  color: var(--color-text);
}

@media (max-width: 1024px) {
  .seller-dashboard {
    flex-direction: column;
  }

  .main-content {
    width: 100%;
    margin-left: 0;
    padding-top: 1rem;
  }

  .content-wrapper {
    border-radius: 24px;
  }
}
</style>
